/**
 * Results
 *
 * Module Description
 *
 * @return {type}
 */

OT.createNS('OT.Search.Requests.Results');

OT.Search.Requests.Results = (function() {

    var timer = new Timer({
        duration: 30,
        10: function() {
            OT.Events.fire('results:slow');
        },
        onStop: function(mill) {
            OT.Search.sendLogRequest('_ResponseTime', 'interaction', {
                responseTime: mill
            });
        },
        onEnd: function() {
            OT.Events.fire('results:cancel');
        }
    });

    var resultRetries = 0,
        defaults = {
            onSuccess: function() {},
            onFailure: function() {},
            always: function() {},
            additionalData: {},
            supressEvents: false,
            retry: true
        };

    var getResults = function(options) {
        // Check if JS rendering is enabled. If not, then redirect to the correct URL based on the logEventPrefix.
        // This should probably be changed, but it SHOULD only be temporary.
        if(!OT.Search.Config.get('enableJSRendering')) {
            OT.Common.Helpers.redirectWindow(OT.Search.Requests.BuildUrl[OT.Search.Config.get('logEventPrefix').toLowerCase()]());
            return false;
        }

        var opts = _.defaults(options || {}, _.clone(defaults));

        // Trigger the 'getting results' event
        if(!opts.supressEvents) {
            OT.Events.fire('results:get', [opts.additionalData]);
        }

        opts.url            = opts.url || OT.Search.Requests.BuildUrl.api();
        opts.additionalData = opts.additionalData || {};

        if(resultRetries === 0) {
            timer.start();
        }

        var success = function(data) {
            processResults(opts, data, timer);
            cancel();
        };

        var failure = function(xhr, response, errorMsg) {
            OT.Events.fire('results:failed');
            OT.Events.fire('results:error', [errorMsg]);

            if(opts.retry) {
                retryResults(opts, errorMsg);
            }
        };

        $.ajax({
            url: opts.url,
            type: 'POST',
            headers: OT.Common.Helpers.buildRequestHeaders(),
            dataType: 'json'
        })
        .done(success)
        .done(opts.onSuccess)
        .fail(failure)
        .fail(opts.onFailure)
        .always(OT.BestAnalytics.logRequest)
        .always(opts.always);
    };

    var cancel = function() {
        opts = null;
        resultRetries = 0;
    };

    var processResults = function(opts, data, timer) {
        OT.Search.Data.set(_.omit(data, 'Experiments'));

        timer.stop();

        if(!opts.additionalData.supressHistory) {
            OT.Search.History.update();
        }

        if(!opts.supressEvents) {
            OT.Events.fire('results:updated', [opts.additionalData]);
            OT.Events.fire('results:done', [opts.additionalData]);
        }

        if (OT.Search.Data.get().Display && OT.Search.Data.get().Display.IsInitialLoad) {
            $('body').addClass('initial-load');
        } else {
            $('body').removeClass('initial-load');
        }
    };

    var retryResults = function(opts, errorMsg) {
        OT.Events.fire('results:retry', [errorMsg, opts.additionalData]);

        if(resultRetries > OT.Search.Config.get('resultRetriesMax')) {
            OT.Events.fire('results:cancel', [errorMsg, opts.additionalData]);
        }

        setTimeout(function() {
            getResults(opts);
        }, resultRetries * 2000);

        resultRetries++;
    };

    return {
        get: getResults,
        cancel: cancel
    };

})();
